<template>
  <div class="login">
    <el-container>
      <el-header class="header">{{this.$store.getters.getHeaderContent}}</el-header>
      <el-main class="lbody">
        <el-form class="lform" :rules="rules" :model="form" ref="form" label-width="100px">
          <img class="llogo" src="../../assets/bes_logo.png"/>
          <el-form-item label="Username" prop="name">
            <el-input v-model="form.name"
                      placeholder="Please enter here"></el-input>
          </el-form-item>
          <el-form-item label="Password" prop="password">
            <el-input v-model="form.password" placeholder="Please enter here"
                      show-password></el-input>
            <!--<div style="display: flex;margin-top: 10px">-->
            <!--<el-link href="/#/Constractor" target="_blank" type="info" style="">Change password</el-link>-->
            <!--<el-link href="/#/rfirfa" target="_blank" type="info" style="margin-left: 20%">Forgot password?</el-link>-->
            <!--</div>-->
          </el-form-item>
          <el-form-item label-width="0px">
            <el-button id="login_btn" class="login_buttom" type="primary" @click="login">Login</el-button>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import axios from 'axios'
import md5 from 'js-md5';

export default {
  name: "login",
  data() {
    return {
      form: {
        name: '',
        password: ''
      },
      rules: {
        name: [
          {
            required: true,
            message: 'Please input your username or mobile phone number.',
            trigger: 'blur'
          },
          // {min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur'},
          {min: 6, max: 20, message: 'Length of 6 to 20 characters', trigger: 'blur'},
          {pattern: /^[A-Za-z0-9]+$/, message: 'Containing illegal characters'}
        ],
        password: [
          {required: true, message: 'Please input your password', trigger: 'blur'},
          {min: 6, max: 20, message: 'Length of 6 to 20 characters', trigger: 'blur'}
        ],
      }
    }
  },
  methods: {

    empty() {  //用户名或密码错误后清空输入框
      this.form.name = "";
      this.form.password = "";
    },

    login() {
      //18615146587   123456
      let name = this.form.name
      let password = this.form.password

      if (name.length >= 6 && name.length <= 20 && password.length >= 6 && password.length <= 20) {
        let postData = {user: name, password: md5(password), client: 'dashboard', skey: md5('123456')}
        axios.post(this.$store.getters.getCmsServer + "DBUserLogin", postData).then(response => {  //生产
          let errNo = response.data.errno
          let errStr = response.data.errstr
          if (errNo == "0") {
            this.$store.dispatch('saveCompanyId', response.data.result.c_company_id)
            window.localStorage.setItem('token', response.data.result.token)
            window.localStorage.setItem('token_key', name)
            window.localStorage.setItem('role', response.data.result.role)
            window.localStorage.setItem('cons_id', response.data.result.c_company_id)
            window.localStorage.setItem('cons_name', response.data.result.cname)
            window.localStorage.setItem('bes_company_id', response.data.result.bes_company_id)
            var pros = response.data.result.projects
            if (response.data.result.dvurl && response.data.result.dvurl != "") {
              if (response.data.result.role != "1") {
                window.localStorage.setItem('model_list', response.data.result.model_list.toLowerCase())
                if (pros.length > 0) {
                  var first_proid = pros[0].c_project_id
                  var bes_proid = pros[0].bes_project_id
                  window.localStorage.setItem('pros', JSON.stringify(pros))
                  window.localStorage.setItem('pro_index', 0)
                  window.localStorage.setItem('bes_project_id', bes_proid)
                  // var first_proid = response.data.result.project_id.split(',')[0]
                  this.$router.push('/dashboard?proj_id=' + first_proid)
                  history.pushState(null, null, document.URL)
                  window.addEventListener(
                    "popstate",
                    function (e) {
                      history.pushState(null, null, document.URL)
                    },
                    false
                  )
                } else {
                  alert('No project!')
                }
              } else {
                window.location.href = response.data.result.dvurl
              }
            } else {
              window.localStorage.setItem('model_list', 'all')
              this.$router.push('/Constractor')
              history.pushState(null, null, document.URL)
              window.addEventListener(
                "popstate",
                function (e) {
                  history.pushState(null, null, document.URL)
                },
                false
              )
            }
          } else if (errNo == "1" || errNo == "7") {
            // alert("用户名或密码错误！")
            alert("ERROR Incorrect username or password！")
            this.empty()
          } else {
            alert(errStr)
          }
        }).catch(error => {
          alert("DBUserLogin.error:" + error)
        })
      }
    }
  },
  mounted() {
    document.body.addEventListener('keyup', function (e) {
      if (e.keyCode === 13) {
        let toClick = document.getElementById('login_btn')
        toClick.click()
      }
    })
  }
}
</script>

<style lang="stylus" scoped>
.login
  width 100%
  height 920px

.header
  height: 100px
  width: 100%
  font-size 30px
  color #ccc
  line-height 50px
  text-align center

.lbody
  margin auto
  position absolute
  border-width 5px
  border-radius 1%
  left 0
  right 0
  top 25%
  height 350px
  width 450px
  background-color #ccc
  text-align center

.lform
  position relative
  margin-top 0

.llogo
  position relative
  height 50px
  margin-bottom 20px

.login_buttom
  position relative
  margin auto
  left 0
  right 0
  width 100%
  margin-top 1px
  margin-bottom 10px

</style>



// WEBPACK FOOTER //
// src/components/login/login.vue